import HttpResponse from "../../../../../utils/http/http.response";

export enum OrderCargoOrderDetailsHandlingLogType {
  FORWARD = "FORWARD",
  FORWARD_CANCEL = "FORWARD_CANCEL",
  ACCEPTED_CPE_CANDIDATURE = "ACCEPTED_CPE_CANDIDATURE",
  ACCEPTED_CSO_CANDIDATURE = "ACCEPTED_CSO_CANDIDATURE",
  ACCEPTED_DSO_CANDIDATURE = "ACCEPTED_DSO_CANDIDATURE",
}

export type OrderCargoOrderDetailsHandlingLogResponseDriver = {
  id: string;
  displayName: string;
};

export type OrderCargoOrderDetailsHandlingLogResponseTaxi = {
  id: string;
  displayName: string;
};

export type OrderCargoOrderDetailsHandlingLogResponseContract = {
  id: string;
  displayName: string;
};

export type OrderCargoOrderDetailsHandlingLogResponseAuthor = {
  firstName: string;
  lastName: string;
};

export type OrderCargoOrderDetailsHandlingLogDSOCandidatureAcceptedResponseItem =
  {
    createdAt: Date;
    logType: OrderCargoOrderDetailsHandlingLogType.ACCEPTED_DSO_CANDIDATURE;
    author: OrderCargoOrderDetailsHandlingLogResponseAuthor;
    planEntryHumanId: number;
  };

export type OrderCargoOrderDetailsHandlingLogCSOCandidatureAcceptedResponseItem =
  {
    driver: OrderCargoOrderDetailsHandlingLogResponseDriver;
    taxiCorporation: OrderCargoOrderDetailsHandlingLogResponseTaxi;
    createdAt: Date;
    logType: OrderCargoOrderDetailsHandlingLogType.ACCEPTED_CSO_CANDIDATURE;
    author: OrderCargoOrderDetailsHandlingLogResponseAuthor;
    planEntryHumanId: number;
  };

export type OrderCargoOrderDetailsHandlingLogCPECandidatureAcceptedResponseItem =
  {
    driver: OrderCargoOrderDetailsHandlingLogResponseDriver;
    taxiCorporation: OrderCargoOrderDetailsHandlingLogResponseTaxi;
    createdAt: Date;
    logType: OrderCargoOrderDetailsHandlingLogType.ACCEPTED_CPE_CANDIDATURE;
    author: OrderCargoOrderDetailsHandlingLogResponseAuthor;
  };

export type OrderCargoOrderDetailsHandlingLogResponseItem = {
  createdAt: Date;
  logType: OrderCargoOrderDetailsHandlingLogType.FORWARD;
  author: OrderCargoOrderDetailsHandlingLogResponseAuthor;
  contract: OrderCargoOrderDetailsHandlingLogResponseContract;
};

export type OrderCargoOrderDetailsHandlingLogCancelResponseItem = {
  createdAt: Date;
  logType: OrderCargoOrderDetailsHandlingLogType.FORWARD_CANCEL;
  author: OrderCargoOrderDetailsHandlingLogResponseAuthor;
  producer: OrderCargoOrderDetailsHandlingLogResponseTaxi;
  consumer: OrderCargoOrderDetailsHandlingLogResponseTaxi;
};

export type OrderCargoOrderDetailsHandlingLogResponseData =
  | OrderCargoOrderDetailsHandlingLogResponseItem
  | OrderCargoOrderDetailsHandlingLogCancelResponseItem
  | OrderCargoOrderDetailsHandlingLogCPECandidatureAcceptedResponseItem
  | OrderCargoOrderDetailsHandlingLogCSOCandidatureAcceptedResponseItem
  | OrderCargoOrderDetailsHandlingLogDSOCandidatureAcceptedResponseItem;

type OrderCargoOrderDetailsHandlingLogResponse = HttpResponse<
  OrderCargoOrderDetailsHandlingLogResponseData[]
>;

export default OrderCargoOrderDetailsHandlingLogResponse;
